import React from 'react';
import './LoginSupportMobile.css';

export default function LoginSupportMobile({
  step,
  contactInfo,
  setContactInfo,
  inputText,
  setInputText,
  error,
  loading,
  messages,
  ticketStatus,
  handleStartChat,
  handleSendMessage,
  messagesEndRef,
  onBack
}) {
  if (step === 'input_info') {
    return (
      <div className="mobile-login-support-container" dir="rtl" style={{ padding: '20px', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
         <img src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="Logo" style={{ width: '80px', marginBottom: '15px' ,margin:'auto'}} />
          <h2 style={{ color: '#0b4f6f', fontSize: '22px', fontWeight: '800', margin: 0 }}>الدعم الفني</h2>
          <p style={{ color: '#64748b', fontSize: '14px', marginTop: '5px' }}>الإبلاغ عن مشكلة في تسجيل الدخول</p>
        </div>

        {error && <div style={{ color: '#ef4444', background: '#fef2f2', padding: '10px', borderRadius: '8px', marginBottom: '15px', fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}>{error}</div>}

        <form onSubmit={handleStartChat} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#123a52', marginBottom: '5px' }}>معلومات الحساب</label>
            <input
              type="text"
              placeholder="البريد الإلكتروني، اسم المستخدم، أو الهاتف"
              value={contactInfo}
              onChange={(e) => setContactInfo(e.target.value)}
              required
              style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '1.5px solid #cbd5e1', outline: 'none', fontSize: '15px', boxSizing: 'border-box' }}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#123a52', marginBottom: '5px' }}>وصف المشكلة</label>
            <textarea
              placeholder="اشرح المشكلة بالتفصيل..."
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              required
              rows="4"
              style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '1.5px solid #cbd5e1', outline: 'none', fontSize: '15px', fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '15px', backgroundColor: '#0b4f6f', color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px' }}
          >
            {loading ? 'جاري البدء...' : 'بدء المحادثة'}
          </button>

          <button
            type="button"
            onClick={onBack}
            style={{ width: '100%', padding: '12px', backgroundColor: 'transparent', color: '#64748b', border: 'none', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer' }}
          >
            العودة لتسجيل الدخول
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="mobile-login-support-container" dir="rtl">
      <div className="mobile-support-header">
        <h3>محادثة تسجيل الدخول</h3>
        <button onClick={onBack} style={{ background: '#e2e8f0', border: 'none', padding: '6px 12px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>
          خروج
        </button>
      </div>

      <div className="mobile-support-messages-area">
        {messages.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#94a3b8', marginTop: '50px' }}>جاري تحميل الرسائل...</div>
        ) : (
          messages.map((msg) => (
            <div key={msg.id} className={`mobile-support-msg-wrapper ${msg.sender === 'user' ? 'mobile-support-msg-user' : 'mobile-support-msg-support'}`}>
              <div className={`mobile-support-msg-bubble ${msg.sender === 'user' ? 'mobile-support-bubble-user' : 'mobile-support-bubble-support'}`}>
                {msg.text}
              </div>
              <span className="mobile-support-msg-footer">{msg.footer}</span>
            </div>
          ))
        )}
        <div ref={messagesEndRef} />
      </div>

      <div className="mobile-support-input-area">
        <form onSubmit={handleSendMessage} className="mobile-support-input-form">
          <label htmlFor="mobileLoginChatInput" className="mobile-support-chat-input-label">
            <input
              id="mobileLoginChatInput"
              type="text"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              placeholder={ticketStatus === 'resolved' || ticketStatus === 'closed' ? "التذكرة مغلقة" : "اكتب رسالتك هنا..."}
              className="mobile-support-chat-input"
              disabled={ticketStatus === 'resolved' || ticketStatus === 'closed'}
            />
          </label>
          <button 
            type="submit" 
            className="mobile-support-send-btn"
            disabled={ticketStatus === 'resolved' || ticketStatus === 'closed'}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'scaleX(-1)' }}>
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </form>
        {(ticketStatus === 'resolved' || ticketStatus === 'closed') && (
          <p className="mobile-support-resolved-text">هذه التذكرة مغلقة ولا يمكن الرد عليها.</p>
        )}
      </div>
    </div>
  );
}